import React, { useEffect } from "react";
import BasePartialRejectionDialog from "../SharedComponent/components/BasePartialRejectionDialog";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../config/redux/reducers";
import {
  fetchRejectionReasons,
  fetchRefreshedDataForPCNotReceived,
} from "./redux/planningSlice";
import { bundleRejectionDataTransform } from "./../mocks/routePlanning/response.transforms";
import { rejectionDataTransform } from "./../mocks/SharedTransform/response.transforms";

interface UpdatePartialRejectionProps {
  open: boolean;
  consignment: any;
  items: any;
  bundleProduct?: any;
  closePopup: () => void;
  handleDialogAction?: (params: any) => void;
}

const UpdatePartialRejection = (props: UpdatePartialRejectionProps) => {
  const dispatch = useDispatch();
  const {
    rejectionReasonList,
    revisedAmountAfterCalculation,
  } = useSelector((state: AppState) => state.routePlanning);
  const { countryCode } = useSelector((state: AppState) => state.common);
  const {
    open,
    consignment,
    items,
    closePopup,
    handleDialogAction,
    bundleProduct,
  } = props;

  // Fetch reasons and refresh data if needed
  const fetchReasons = React.useCallback((country: any) => {
    dispatch(fetchRejectionReasons({ countryCode: country }));
  }, [dispatch]);

  // Metadata selector for RoutePlanning
  const metadataSelector = (consignment: any) => consignment?.metadata || {};



  return (
    <BasePartialRejectionDialog
      open={open}
      consignment={consignment}
      items={items}
      bundleProduct={bundleProduct}
      closePopup={closePopup}
      handleDialogAction={handleDialogAction}
      rejectionReasonList={rejectionReasonList}
      revisedAmountAfterCalculation={revisedAmountAfterCalculation}
      fetchRejectionReasons={fetchReasons}
      rejectionDataTransform={rejectionDataTransform}
      bundleRejectionDataTransform={bundleRejectionDataTransform}
      countryCode={countryCode}
      metadataSelector={metadataSelector}
    />
  );
};

export default UpdatePartialRejection;
